export default __webpack_public_path__ + "static/media/quythuc.ccc0817e.png";